module.exports = __webpack_public_path__ + "img/ikonka-06.6d4191c2.svg";